export class StorageUtils {
    static isStorageAvailable(storage: Storage): boolean {
        const uid = new Date().getTime().toString();
        try {
            storage.setItem(uid, uid);
            const itemFromStorage = storage.getItem(uid) === uid;
            storage.removeItem(uid);
            return (itemFromStorage && typeof Storage !== "undefined") ? true : false;
        } catch (e) {
            return false;
        }
    }
}
